// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3EvSw","disabled":"FileBtn_disabled__uoau2","warn":"FileBtn_warn__csrua","fade":"FileBtn_fade__3YsGZ"};